export default "__VITE_ASSET__C$$qIDQt__"